import React, {useState, useEffect, useRef} from 'react';
import {GetServerSidePropsContext} from 'next';
import {getPageData} from '../[[...slug]]/index.page';
import SignupTemplate from '@wearesection/bandai-react-components/organisms/Signup';
import {Box} from '@mui/material';
import {usePageSetting} from '~/providers/page-context.provider';
import userApi from '~/pages/api/services/user-api';
import authorApi from '~/pages/api/services/author-api';
import {COUNTRY_LIST} from '~/constants';
import {setCookie, getCookie} from 'cookies-next';
import cartApi from '../api/services/cart-api';
import {
  GetRouter,
  handelRenderConfigDigitalRiverCheckout,
  handleConvertToLocaleContentful,
  handleCovertLocale,
} from '~/utils';
import Link from 'next/link';
import {getGloablByType} from '~/utils/global-operations';
import {GLOBAL_TYPE} from '~/constants/content-map-type';
import {IPropsLogin} from '../login/index.page';
import {BlockRenderer} from '~/components/renderer/block-renderer';

const Register = (props: IPropsLogin) => {
  const {imageLogin, seo} = props;
  const router = GetRouter();
  const {locale, query} = router;
  const isLogged = getCookie('isLoginSuccess');
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const [openPopupSuccessful, setOpenPopupSuccessful] = useState<boolean>(false);
  const [subcribe, setSubcribe] = useState<boolean>(false);
  const [firstName, setFirstName] = useState<string>('');
  const [errorEmailMessage, setErrorEmailMessage] = useState<string>('');
  const refRegister = useRef<boolean>(true);

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [isOpenPopupIdentity, setIsOpenPopupIdentity] = useState<boolean>(false);

  const [args, setArgs] = useState<any>({
    ...imageLogin,
    alt: 'image',
    title: '',
    description: '',
    acceptNewsCheckbox: {
      label: '',
      isAccept: false,
    },
    policyAndTerms: {
      text: '',
      terms: {
        label: '',
        href: '',
      },
      policy: {
        label: '',
        href: '',
      },
      labelAnd: '',
    },
    locale: locale,
    signupButton: {
      variant: 'primary',
      label: '',
      disabled: true,
      fullWidth: true,
      handler: (event: any, props: any, formData: any) => {},
    },
    firstNameField: {
      label: '',
      helperText: '',
      emptyField: '',
      hiddenLabel: true,
      success: false,
      iconPosEnd: true,
    },
    lastNameField: {
      label: '',
      helperText: '',
      emptyField: '',
      hiddenLabel: true,
      success: false,
      iconPosEnd: true,
    },
    genderField: {
      title: '',
      value: 'Gender',
      disabled: false,
      error: false,
      helperText: '',
      width: '100%',
      data: [
        {
          label: 'Male',
          value: 'Male',
        },
        {
          label: 'Female',
          value: 'Female',
        },
        {
          label: 'Other',
          value: 'Other',
        },
      ],
    },
    dateOfBirthField: {
      label: '',
      helperText: ' YYYY/MM/DD',
      emptyField: '',
      hiddenLabel: true,
      success: false,
      iconPosEnd: true,
      placeholder: 'YYYY/MM/DD',
    },
    locationField: {
      title: '',
      helperText: '',
      width: '100%',
      name: 'location',
      required: true,
      data: COUNTRY_LIST,
      countryDefault: 'Singapore',
    },
    emailField: {
      label: '',
      helperText: '',
      emptyField: '',
      hiddenLabel: true,
      success: false,
      iconPosEnd: true,
    },
    passwordField: {
      label: '',
      emptyField: '',
      helperText: '',
      hiddenLabel: false,
      success: false,
      iconPosEnd: true,
    },
    loginLink: {
      text: '',
      link: {
        label: 'Log in',
        href: '/',
      },
    },
    popupSuccessful: {
      image:
        'https://images.ctfassets.net/hnoi7ctzfs57/4dLqNFjt0Wd1djAajkMEi9/acfe8390c12b9cbe3aec8fefe0c3eedf/Group_124113.svg',
      title: '',
      description: '',
      button: [
        {
          externalLink: `/${locale}/store/games`,
          target: '_parent',
          label: '',
        },
        {
          externalLink: `/${locale}/account`,
          target: '_parent',
          label: '',
        },
      ],
    },
  });
  const KOREA_API_DOMOAIN = process.env.NEXT_PUBLIC_KOREA_API_DOMOAIN;

  useEffect(() => {
    if (isLogged && refRegister.current) {
      router.push(`/${locale}/account`);
      return;
    }
  }, [isLogged, router]);

  const handelReturnLocale = (lc: string) => {
    if (lc === 'tc') {
      const currentToken = getCookie('currentToken');
      if (currentToken === 'HKD') {
        return 'hk-tc';
      }
      if (currentToken === 'TWD') {
        return 'tw-tc';
      }
    }
    return lc;
  };

  const handleSetTokenIntoCookies = (token: string) => {
    setCookie('token', token, {
      httpOnly: false,
      maxAge: 60 * 60 * 24,
    });
    setCookie('isLoginSuccess', 'true', {
      httpOnly: false,
      maxAge: 60 * 60 * 24,
    });
  };

  const returnQuery = () => {
    let result = '';
    for (const [key, value] of Object.entries(query)) {
      result += `${key}=${value}&`;
    }
    return result;
  };

  const handleSignup = async (
    firstName: string,
    lastName: string,
    gender: string,
    dateOfBirth: string,
    location: string,
    email: string,
    password: string,
    subcribeValue: boolean
  ) => {
    setLoadingSubmit(true);
    const bodyFormData = new FormData();
    const currencyCode = getCookie('currentToken') || 'SGD';
    refRegister.current = false;
    const data = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      password: password,
      currencyCode: currencyCode,
      language: handleCovertLocale(`${locale}`.toLowerCase()),
    };

    // Data for subcribe
    bodyFormData.append('email', email);

    bodyFormData.append('locale', locale as string);

    // ================= Madive =================
    let niceAuthKey: string | null = '';
    let checkNiceAuth = false;
    // Open NiceAuth window popup
    if (`${locale}`.toLowerCase() === 'ko-kr' && typeof window !== 'undefined') {
      checkNiceAuth = await new Promise<boolean>(resolve => {
        /************************************************************************************************
             In Korea, usually use last name and first name at once. Also Last name comes at front and First name comes at back.
             Example: Other county naming: except Korea -> "John Nam" // In Korea -> "Nam John" (Last name comes at front).

             Need to compare NiceAuth user name with register's user name input value.
             ************************************************************************************************/
        const KR_FULL_NAME = (lastName + firstName).trim();
        const KR_CUSTOMER_INFO = window.btoa(encodeURIComponent(`${KR_FULL_NAME}##${email}`));
        console.log('Korean Full Name: ' + KR_FULL_NAME);

        const newWindow = window.open(
          `${KOREA_API_DOMOAIN}/niceAuth/authMain?authInfo=${KR_CUSTOMER_INFO}`,
          'postMsgPop',
          'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no'
        );

        const handleMessage = (e: MessageEvent) => {
          const {
            origin,
            data: {key: msgDataKey},
          } = e;

          if (origin !== KOREA_API_DOMOAIN) {
            return;
          }

          niceAuthKey = msgDataKey;

          if (niceAuthKey !== '') {
            newWindow?.close();
            resolve(true);
          } else {
            resolve(false);
          }
        };

        const checkPopupClosed = () => {
          if (newWindow && newWindow.closed && !niceAuthKey) {
            // alert('나이스 본인인증이 취소 되었습니다.');
            // setErrorEmailMessage(dataTranslation['estore-signup-email-field-error-message']);
            setLoadingSubmit(false);
          } else {
            setTimeout(checkPopupClosed, 100); // Check if the NiceAuth pop-up cloesd.
          }
        };

        checkPopupClosed();

        if (newWindow) {
          window.addEventListener('message', handleMessage);
        }
      });

      console.log('Check Nice auth status ', checkNiceAuth);

      if (!checkNiceAuth) {
        setIsOpenPopupIdentity(true);
        setLoadingSubmit(false);
        return;
      }
    }

    await authorApi
      ?.register(data)
      .then(async resRegister => {
        if (resRegister.status !== 200) {
          throw resRegister;
        }
        // subscribe if user unchecks on checkbox
        if (!subcribeValue || (`${locale}`.toLowerCase() === 'ko-kr' && subcribeValue)) {
          userApi
            .subcribeEmail(bodyFormData)
            .then(resSubcribe => {
              if (resSubcribe?.status !== 200) {
                throw resSubcribe;
              }
            })
            .catch(error => {
              console.log('error', error);
            });
        }

        // login after registration
        await authorApi
          ?.login({...data, isLocal: process.env.NEXT_PUBLIC_IS_LOCAL || false})
          .then(async (resLogin: any) => {
            if (resLogin?.status !== 200) {
              throw resLogin;
            }
            const token = resLogin.data?.response.token || '';
            handleSetTokenIntoCookies(token);
            // const cartToken = getCookie('cartToken') as string;
            // // update cart
            // if (cartToken) {
            //   // handle update cart for user
            //   await cartApi
            //     .updateCustomerIdCart()
            //     .then(async (resUpdateCustomerId: any) => {
            //       if (resUpdateCustomerId?.status !== 200) {
            //         throw resUpdateCustomerId;
            //       }
            //     })
            //     .catch(e => {
            //       console.log(e);
            //       router.push('/login?ck=true');
            //     });
            // }

            // checkout
            if (`${query?.ck}` === 'true') {
              // handle get checkout
              await cartApi
                .checkoutCart(token)
                .then(async (res: any) => {
                  if (res?.status !== 200) {
                    throw res;
                  }
                  if (res?.data) {
                    // checkout for TC
                    if (`${locale}`.toLowerCase() === 'tc') {
                      //@ts-expect-error
                      const drCheckout = new DigitalRiverCheckout(
                        process.env.NEXT_PUBLIC_DR_PUBLIC_KEY
                      );
                      const bcCartId = res?.data?.cartId || '';
                      if (bcCartId) {
                        drCheckout
                          .createCheckoutSessionWithUpstreamToken({
                            upstreamToken: bcCartId,
                            shoppingCountry: currencyCode === 'TWD' ? 'TW' : 'HK',
                            currency: currencyCode,
                          })
                          .then((checkoutSession: any) => {
                            drCheckout.createModal(checkoutSession.id, {
                              ...handelRenderConfigDigitalRiverCheckout(`${currencyCode}`),
                              onCheckoutComplete: (order: any) => {
                                router.push(`/${locale}/account`);
                              },
                              onClose: () => {
                                router.push(`/${locale}/account`);
                              },
                            });
                          })
                          .catch((err: any) => {
                            console.log(err);
                          });
                      }
                      return;
                    }
                    window.location.href = res?.data?.url;
                    return;
                  }
                })
                .catch(() => {
                  router.push(`/${locale}/account`);
                });
              return;
            }

            // handle buy now
            if (`${query?.by_now}` === 'true' && `${query?.item}`) {
              const item = JSON.parse((query?.item as string) || '{}');

              if (Object.keys(item)?.length === 4) {
                await cartApi
                  .buyNow(item)
                  .then(async res => {
                    if (res?.status !== 200) {
                      throw res;
                    }
                    // checkout for TC
                    if (`${locale}`.toLowerCase() === 'tc') {
                      //@ts-expect-error
                      const drCheckout = new DigitalRiverCheckout(
                        process.env.NEXT_PUBLIC_DR_PUBLIC_KEY
                      );
                      const bcCartId = res?.data?.cartId || '';
                      if (bcCartId) {
                        drCheckout
                          .createCheckoutSessionWithUpstreamToken({
                            upstreamToken: bcCartId,
                            shoppingCountry: currencyCode === 'TWD' ? 'TW' : 'HK',
                            currency: currencyCode,
                          })
                          .then((checkoutSession: any) => {
                            drCheckout.createModal(checkoutSession.id, {
                              ...handelRenderConfigDigitalRiverCheckout(`${currencyCode}`),
                              onCheckoutComplete: (order: any) => {
                                router.push(`/${locale}/account`);
                              },
                              onClose: () => {
                                router.push(`/${locale}/account`);
                              },
                            });
                          })
                          .catch((err: any) => {
                            console.log(err);
                          });
                      }
                      return;
                    }
                    const url = res?.data?.url;
                    if (url) {
                      window.location.href = url;
                    }
                    return;
                  })
                  .catch(() => {
                    router.push(`/${locale}/account`);
                  });
                return;
              }
            }
          })
          .catch(() => {
            if (!Object.keys(query)?.length) {
              return router.push(`/${locale}/login`);
            }
            router.push(`/${locale}/login?${returnQuery()}`);
          });
        setFirstName(firstName);
        setOpenPopupSuccessful(true);
      })
      .catch(error => {
        setLoadingSubmit(false);
        if (error.response.status === 422) {
          setErrorEmailMessage(dataTranslation['estore-signup-email-field-error-message']);
        }
      });
  };

  const handleCheckEmail = (email: any, callback: (err: any) => void) => {
    authorApi
      .validateEmail({email})
      .then((res: any) => {
        if (res?.status !== 200) {
          throw res;
        }
        const data = res?.data || false;
        if (data) {
          callback(dataTranslation['estore-email-error-duplicate'] || '');
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (Object.keys(dataTranslation)?.length && typeof window !== 'undefined') {
      const newLocale = handelReturnLocale(`${locale}`.toLowerCase());
      const argsNew = {
        ...imageLogin,
        alt: 'image',
        title: dataTranslation['estore-signup-title'],
        description: dataTranslation['estore-signup-description'],
        acceptNewsCheckbox: {
          label: dataTranslation['estore-signup-checkbox-accept-news'],
          isAccept: false,
        },
        policyAndTerms: {
          text: dataTranslation['estore-signup-policy-and-terms-text'],
          terms: {
            label: dataTranslation['estore-signup-terms-label'],
            href: `/${newLocale}/terms-of-use`,
          },
          policy: {
            label: dataTranslation['estore-signup-policy-label'],
            href: `/${newLocale}/privacy-policy`,
          },
          labelAnd: dataTranslation['filter-news-and'] || '',
        },
        locale: locale,
        signupButton: {},
        firstNameField: {
          label: dataTranslation['estore-signup-firstname-field-label'] ?? '',
          helperText: '',
          emptyField: dataTranslation['estore-signup-firstname-field-empty'] ?? '',
          hiddenLabel: true,
          success: false,
          iconPosEnd: true,
        },
        lastNameField: {
          label: dataTranslation['estore-signup-lastname-field-label'] ?? '',
          helperText: '',
          emptyField: dataTranslation['estore-signup-lastname-field-empty'] ?? '',
          hiddenLabel: true,
          success: false,
          iconPosEnd: true,
        },
        genderField: {
          title: dataTranslation['estore-signup-gender-field-title'],
          value: 'Gender',
          disabled: false,
          error: false,
          helperText: dataTranslation['estore-signup-gender-field-helper-text'],
          width: '100%',
          data: [
            {
              label: 'Male',
              value: 'Male',
            },
            {
              label: 'Female',
              value: 'Female',
            },
            {
              label: 'Other',
              value: 'Other',
            },
          ],
        },
        dateOfBirthField: {
          label: dataTranslation['estore-signup-dateOfBirth-field-title'],
          helperText:
            dataTranslation['estore-signup-dateOfBirth-field-helper-text'] + ' YYYY/MM/DD',
          emptyField: dataTranslation['estore-signup-dateOfBirth-field-helper-empty'],
          hiddenLabel: true,
          success: false,
          iconPosEnd: true,
          placeholder: 'YYYY/MM/DD',
        },
        locationField: {
          title: dataTranslation['estore-signup-location-field-title'],
          helperText: dataTranslation['estore-signup-location-field-helper-text'],
          width: '100%',
          name: 'location',
          required: true,
          data: COUNTRY_LIST,
          countryDefault: 'Singapore',
        },
        emailField: {
          label: dataTranslation['estore-signup-email-field-label'] ?? '',
          helperText:
            (errorEmailMessage || dataTranslation['estore-signup-email-field-helper-text']) ?? '',
          emptyField: dataTranslation['estore-signup-email-field-empty'] ?? '',
          hiddenLabel: true,
          success: false,
          iconPosEnd: true,
        },
        passwordField: {
          label: dataTranslation['estore-signup-password-field-label'] ?? '',
          emptyField: dataTranslation['estore-signup-password-field-empty'] ?? '',
          helperText: dataTranslation['estore-signup-password-field-helper-text'] ?? '',
          hiddenLabel: false,
          success: false,
          iconPosEnd: true,
        },
        loginLink: {
          text: dataTranslation['estore-signup-login-link-text'] ?? '',
          link: {
            label: 'Log in',
            href: '/',
          },
        },
        nextLink: (
          <Link href={`/${locale}/login`}>
            <a>{dataTranslation['estore-signup-login-link-label'] ?? ''}</a>
          </Link>
        ),
        popupSuccessful: {
          image:
            'https://images.ctfassets.net/hnoi7ctzfs57/4dLqNFjt0Wd1djAajkMEi9/acfe8390c12b9cbe3aec8fefe0c3eedf/Group_124113.svg',
          title: `${dataTranslation['estore-signup-popup-successful-title']} ${firstName}!` ?? '',
          description: dataTranslation['estore-signup-popup-successful-description'] ?? '',
          button: [
            {
              externalLink: `/${locale}/store/games`,
              target: '_parent',
              label:
                dataTranslation['estore-signup-popup-successful-button-shop-games-label'] ?? '',
            },
            {
              externalLink: `/${locale}/account`,
              target: '_parent',
              label:
                dataTranslation['estore-signup-popup-successful-button-see-your-account-label'] ??
                '',
            },
          ],
        },
      };
      setArgs(argsNew);
    }
  }, [locale, router, dataTranslation]);

  const SeoStandard = seo?.register
    ? {
        __typename: 'SeoStandard',
        ...seo.register,
      }
    : null;

  return (
    <Box
      sx={{
        paddingBottom: '80px',
      }}
    >
      {SeoStandard && <BlockRenderer block={[SeoStandard]} />}
      <SignupTemplate
        {...args}
        signupButton={{
          variant: 'primary',
          label: dataTranslation['estore-signup-button-label'],
          disabled: true,
          fullWidth: true,
          handler: async (event: any, props: any, formData: any) => {
            handleSignup(
              formData?.firstName,
              formData?.lastName,
              formData?.gender,
              formData?.dateOfBirth,
              formData?.location,
              formData?.email,
              formData?.password,
              subcribe
            );
            setErrorEmailMessage('');
          },
        }}
        openPopupSuccessful={openPopupSuccessful}
        onSubcribe={(e: any) => setSubcribe(e)}
        errorEmailMessage={errorEmailMessage}
        onCheckEmail={handleCheckEmail}
        messageErrorPass={{
          errorCharacter: dataTranslation['estore-error-pass-character'],
          error1lowercase: dataTranslation['estore-error-pass-one-lowercase'],
          error1uppercase: dataTranslation['estore-error-pass-one-uppercase'],
          error1special: dataTranslation['estore-error-pass-one-special'],
          error1number: dataTranslation['estore-error-pass-one-number'],
        }}
        locale={`${locale}`.toLowerCase()}
        contentCheckboxKoKr={{
          leastOld: dataTranslation['estore-register-leastOld'] || '',
          termsConditions: dataTranslation['estore-register-termsConditions'] || '',
          // '<a href="/ko-kr/terms-of-use" target="_blank">이용 약관</a>에 동의합니다.',
          privacyPolicy: dataTranslation['estore-register-privacyPolicy'] || '',
          // '<a href="/ko-kr/privacy-policy" target="_blank">개인정보처리방침</a>에 동의합니다',
        }}
        contentPopupIdentity={{
          title: 'Let’s verify your identity',
          isOpen: false,
          description:
            'Before creating an account with us, we need you to verify your identity through your mobile carrier.',
          buttonProps: {
            variant: 'secondary',
            label: 'Verify with carrier',
            handler: () => {},
          },
        }}
        loadingSubmit={loadingSubmit}
        isOpenPopupIdentity={isOpenPopupIdentity}
        onClosePopupIdentity={() => setIsOpenPopupIdentity(false)}
      />
    </Box>
  );
};
export const getStaticProps = async (ctx: GetServerSidePropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);
  const promises: [
    ReturnType<typeof getPageData>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>
  ] = [
    getPageData({slug: 'store', preview}, ctx),
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.ImageLogin),
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.SEO),
  ];
  const [pageData, imageLogin, seo] = await Promise.all(promises);
  const {data} = pageData;

  return {
    props: {
      data,
      imageLogin,
      seo,
    },
    revalidate: 60 * 5,
  };
};
export default Register;
